export default {
  code: 'Please enter the verification code you received',
  phone: 'Phone',
  step1: 'Fill info',
  step2: 'Create account',
  step3: 'Complete registry',
  step4: 'School account',
  editionTip: 'For your best experience, the latest version of Google Chrome or Safari is recommended',
  editionTip1: 'For your best experience, the Google Chrome 69.0, the Safari 10.0 or higher version is recommended.',
  notcie: 'Notice',
  know: 'I See',
  index: {
    text1: 'Parent login',
    text2: 'Sign In',
    text3: 'Forgot Password?',
    text4: 'Reset Password',
    text5: 'Register',
    text6: 'Phone No.',
    text7: 'Password',
    text8: 'Teacher login',
    text9: 'Phone No.',
    text13: 'Phone Number/Email',
    text10: 'Code Login',
    text11: 'Password login',
    text12: 'Office365 login',
    tip: 'You need to bind WeChat to use this feature',
    wxbtn: 'Parent login with Wechat',
    logintip: 'Sign in to your account',
    usernameTip: 'Please enter a valid mobile phone number',
    adminLogin: 'Admin Login',
    normalLogin: 'Normal Login'
  },
  forgetPassword: {
    text1: 'Change Password',
    text2: 'Return Sign In',
    text3: 'Verification of identity',
    text4: 'Reset Password',
    text5: 'Reset Successfully',
    text6: 'Phone No.',
    text7: 'Verification Code',
    text8: 'Reset Password',
    text9: 'Confirm the password',
    text10: 'Your password has been reset.',
    text11: 'return to sign in page.',
    text12: 'Return logon',
    text13: 'Log In',
    rightTip1: 'Enter your mobile number, a verification code will be sent to your mobile phone.',
    rightTip2: 'Enter and confirm your password. Your password should be at least 6-16 digits.',
    rightTip3: 'Thank you, your password has been changed!',
    step1Tip1: 'Verify mobile phone number or email',
    step1Tip2: 'Verification',
    step2Tip1: 'Setting a new password',
    step2Tip2: 'Recovery',
    step3Tip: 'Password Reset Successful'
  },
  register: {
    text1: 'Register',
    text2: 'Sign in',
    text3: 'NCIC Curriculum Home',
    text4: 'Verify Phone No.',
    text5: 'Enter Account Info.',
    text6: 'Register Successfully',
    text7: 'New account registration success!',
    text8: 'Scanning these two-dimensional codes and subscribing to school s official account allows you to view campus visits and evaluation information on the service number.',
    text9: 'Completion of registration',
    text10: 'Focus on Wechat Public Number',
    text11: 'Create accounts and passwords',
    formtext1: 'Phone No.',
    formtext2: 'Verification code',
    formtext3: 'Email',
    formtext4: 'Set password ',
    formtext5: 'Confirm password',
    formtext6: 'Nationality',
    formtext66: 'Please choose',
    formtext7: 'First name',
    formtext8: 'Middle name',
    formtext9: 'Last name',
    formtext10: 'Full name',
    formtext11: 'Gender',
    formtext12: 'Male',
    formtext13: 'Female sex',
    indexReg1: 'Your account has been registered!',
    indexReg2: 'Welcome to',
    indexReg3: 'NCIC course',
    indexReg4: ' seconds later it will jump to login.',
    rightTip1: 'Enter your mobile number, a verification code will  be sent to your mobile phone.',
    rightTip2: 'Enter your details. Such as your name and gender.',
    rightTip3: 'Thank you, you have successfully registered. You can login now.',
    step1Tip1: 'Mobile Number',
    step1Tip2: 'Verification',
    step2Tip1: 'Enter Your',
    step2Tip2: 'Details',
    step3Tip: 'You have registered!',
    title: 'Create a New Account',
    subText: 'Please enter your details',
    submit: 'Submit',
    success: "Congratulations! You've registered sucessfully.",
    backLogin: 'Back to Login',
    bindWX: 'Bind WeChat Account',
    bindWXSub: 'Use shortcut login of WeChat',
    bindNow: 'Bind Immediately',
    removeBind: 'Unbind',
    binded: 'Bound WeChat Account',
    fllow: 'Follow School WeChat Official Account',
    fllowSub: 'Keep track of the latest development of school',
    fllowNow: 'Follow Immediately',
    fllowed: 'Followed',
    fllowTips: 'Scan and subscribe Immersion offical account,youwill be able to check the campus tour and assessment information on your WeChat.',
    hasAccount: 'Already have an account? Please log in.',
    sex0: 'Unkown',
    sex1: 'Male',
    sex2: 'Female'
  }
}



// WEBPACK FOOTER //
// ./src/views/login/lang/en.js